<template>
  <div class="PayLedger">
    <div>
      <ATable
        ref="table"
        v-loading="loading"
        buttons-width="300px"
        max-height="365px"
        :summaryTitleColumnIndex="2"
        :summaryFields="summaryFields"
        :data="items"
        :disabled="disabled"
        show-summary
        hide-pagination
        hide-button-insert
        border
        @row-click="handleRowClickCollect"
      >
        <div slot="search">
          <div class="inline">
            <div class="inline bold">결제기간</div>
            <APeriodSelector
              ref="period" 
              class="inline ml-default"
              :value="search_period"
              :disabled="disabled"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="pay_way_flag"
          label="결제 방법"
          width="120"
          :formatter="resolveCollectWay"
        />
        <el-table-column
          prop="pay_date"
          label="결제 일자"
          :formatter="util.dateFormat"
          :width="$width.date"
        />
        <el-table-column
          prop="price"
          label="결제액"        
          width="120"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="discount_price"
          label="할인액"        
          width="120"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="real_price"
          label="실결제액"        
          width="120"
          class-name="cell-number"
          :formatter="resolveRealPrice"
        />
        <el-table-column
          prop="desc"
          label="비고"
          show-overflow-tooltip
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button 
            type="primary" 
            :disabled="disabled || !has_grant_write"
            @click="handleClickCreateCollect"
          >결제 등록</el-button>
        </div>
      </ATable>
    </div>
    <div>
      <ATable
        ref="table2"
        v-loading="loading2"
        buttons-width="300px"        
        max-height="365px"
        :data="items2"
        :disabled="disabled"
        hide-button-insert
        hide-pagination
        border
        @row-click="handleRowClickNote"
      >
        <el-table-column 
          type="index" 
          label="No" 
          :index="handleIndex2" 
          :width="$width.index" 
        />
        <el-table-column 
          prop="number" 
          label="어음번호" 
          width="100" 
        />
        <el-table-column 
          prop="type_flag" 
          label="구분" 
          width="50"
          :formatter="resolveTypeFlag" 
        />
        <el-table-column 
          prop="out_date" 
          label="출고일" 
          :width="$width.date"
        />
        <el-table-column 
          prop="pay_date" 
          label="결제일" 
          :width="$width.date"
        />
        <el-table-column
          prop="price"
          label="금액"
          width="100"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="desc" 
          label="기록사항" 
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="publish_date" 
          label="발행일" 
          :width="$width.date"
        />
        <el-table-column 
          prop="publisher" 
          label="발행자" 
          width="100"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="bank_name" 
          label="발행은행" 
          width="100"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser1" 
          label="배서인1" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser2" 
          label="배서인2" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser3" 
          label="배서인3" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="disabled || !has_grant_write"
            @click="handleClickCreateNote"
          >어음등록</el-button>
        </div>
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="결제 등록"
      :visible.sync="dialog_visible"      
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <PayForm 
        ref="form" 
        v-if="dialog_visible"
        :customer="customer" 
        :data="form_data"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
      />
    </el-dialog>
    <el-dialog
      top="0"
      custom-class="form-dialog"
      title="어음 등록"
      :close-on-click-modal="false"
      :visible.sync="dialog2_visible"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened('form2')"
    >
      <NoteForm 
        ref="form2" 
        v-if="dialog2_visible"
        noteFlag="out"
        :data="form_data2" 
        :outCustomer="customer"
        :has_grant_write="has_grant_write"
        @completed="handleCompleted2"
      ></NoteForm>
    </el-dialog>
  </div>
</template>
<script>
import {form_container} from "@/common/mixins/form_container";
import { account_form } from "@/common/mixins/account_form";
import PayForm from "./PayForm";
import NoteForm from "@/spa/Common/NoteForm";

export default {
  name: "PayLedger",
  mixins: [form_container, account_form],
  components: {PayForm, NoteForm},
  data() {
    return {
      title: this.$t("title.buy_ledger"),
      items: [],
      items2: [],
      search_period: {value: '0d'},
      summaryFields: ["price", "discount_price", "real_price"],
      period: {},
      loading: false,
      loading2: false,
      form_data: null,
      dialog_visible: false,
      form_data2: null,
      dialog2_visible: false,
    }
  },
  props: {
    customer: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer: function() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      if (!this.customer) { return; }
      this.loadPay();
      this.loadNote();
    },
    loadPay() {
      this.loading = true;
      this.api.listPay(this.customer.id, this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    loadNote() {
      this.loading2 = true;
      this.api.listNoteOut(this.customer.id, this.period).then(res => {
        this.loading2 = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items2 = res.data;
      });
    },
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      if (data) {
        let hasBig = this.items.some(item => {
          return item.id > data.id;
        });
        clone.last = !hasBig;
      }
      this.form_data = clone;
      this.getPayWayFlag(this.form_data);
      this.dialog_visible = true;
    },
    openDialog2(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data2 = clone;
      this.dialog2_visible = true;
    },
    resolveCollectWay(row, cell, value) { 
      if( value == '2' ) {
        return this.getBankAccountName(row.account_id);
      }     
      let pay_way = this.system.options.pay_way_flag.find(item => {
        return item.value == value;
      });
      return pay_way ? pay_way.label : null;
    },
    resolveTypeFlag(row, column, value) {
      let flag = this.system.options.note_type_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveInFlag(row, column, value) {
      let flag = this.system.options.note_in_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveOutFlag(row, column, value) {
      let flag = this.system.options.note_out_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveRealPrice(row) {
      row.real_price = row.price - row.discount_price;
      return this.util.addComma(row.price - row.discount_price);
    },
    handleChangePeriod(period) {
      this.period = period;
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleRowClickCollect(row) {
      this.openDialog(row);
    },
    handleClickCreateCollect() {
      this.openDialog();
    },
    handleIndex2(index) {
      return this.$refs.table2.indexResolver(index);
    },
    handleRowClickNote(row) {
      this.openDialog2(row);
    },    
    handleClickCreateNote() {
      this.openDialog2();
    },
    handleCompleted(result) {
      this.dialog_visible = false;      
      this.form_data = undefined;
      if (!result) {
        return;
      }
      this.loadPay();
    },
    handleCompleted2(result) {
      this.dialog2_visible = false;      
      this.form_data2 = undefined;
      if (!result) {
        return;
      }
      this.loadPay();
      this.loadNote();
    },
  },
}
</script>